import React from "react";
import ReactModal from "react-modal";

import styles from "./Modal.module.scss";

ReactModal.setAppElement("#wrapper");

export default function Modal({ isOpen, onClose, children }) {
  if (isOpen) {
    document.querySelector('body').classList.add('Modal__open');
  } else {
    document.querySelector('body').classList.remove('Modal__open');
  }

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      // shouldCloseOnOverlayClick={true}
      style={{
        content: {
          inset: "0",
          border: "none",
          background: "none",
          borderRadius: "0",
          padding: "0",
        },
        overlay: { zIndex: "10" },
      }}
    >
      <div className={styles.background} onClick={onClose}>
        <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
          <button onClick={onClose} className={styles.x}>
            ×
          </button>
          {children}
        </div>
      </div>
    </ReactModal>
  );
}
